import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { commonRequest } from "@devowl-wp/utils";
import { locationRestConsentPost } from "../wp-api";
import { getOptionsFromWindow } from "../utils";
import { applyCookies, applyConsentForwarding } from ".";
/**
 * Save consent to the backend and apply cookies on running session.
 */

function applyConsent(_x) {
  return _applyConsent.apply(this, arguments);
}

function _applyConsent() {
  _applyConsent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var consent, _ref$markAsDoNotTrack, markAsDoNotTrack, buttonClicked, _ref$blocker, blocker, tcfString, _getOptionsFromWindow, restNamespace, restRoot, restQuery, isRefreshSiteAfterConsent, _document$documentEle, clientWidth, clientHeight, _yield$commonRequest, forward;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            consent = _ref.consent, _ref$markAsDoNotTrack = _ref.markAsDoNotTrack, markAsDoNotTrack = _ref$markAsDoNotTrack === void 0 ? false : _ref$markAsDoNotTrack, buttonClicked = _ref.buttonClicked, _ref$blocker = _ref.blocker, blocker = _ref$blocker === void 0 ? 0 : _ref$blocker, tcfString = _ref.tcfString;
            _getOptionsFromWindow = getOptionsFromWindow(), restNamespace = _getOptionsFromWindow.restNamespace, restRoot = _getOptionsFromWindow.restRoot, restQuery = _getOptionsFromWindow.restQuery, isRefreshSiteAfterConsent = _getOptionsFromWindow.others.isRefreshSiteAfterConsent;
            _document$documentEle = document.documentElement, clientWidth = _document$documentEle.clientWidth, clientHeight = _document$documentEle.clientHeight; // Use `commonRequest` cause on frontend we do not have `wp.i18n` available

            _context.next = 5;
            return commonRequest({
              location: locationRestConsentPost,
              options: {
                restNamespace: restNamespace,
                restRoot: restRoot,
                restQuery: restQuery
              },
              request: _objectSpread(_objectSpread({}, consent), {}, {
                markAsDoNotTrack: markAsDoNotTrack,
                buttonClicked: buttonClicked,
                viewPortWidth: clientWidth,
                viewPortHeight: clientHeight,
                blocker: blocker,
                tcfString: tcfString
              }),
              params: {
                _wp_http_referer: window.location.href
              }
            });

          case 5:
            _yield$commonRequest = _context.sent;
            forward = _yield$commonRequest.forward;

            if (!isRefreshSiteAfterConsent) {
              _context.next = 15;
              break;
            }

            _context.t0 = forward;

            if (!_context.t0) {
              _context.next = 12;
              break;
            }

            _context.next = 12;
            return applyConsentForwarding(forward);

          case 12:
            window.location.reload();
            _context.next = 18;
            break;

          case 15:
            // Apply consent forwarding without waiting for all requests
            forward && applyConsentForwarding(forward);
            _context.next = 18;
            return applyCookies("consent");

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _applyConsent.apply(this, arguments);
}

export { applyConsent };